import React from 'react';

import { Button, ButtonProps, Menu } from '@mantine/core';
import { IconDownload, IconJson, IconPdf } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { ExportType } from 'shared/constants/export';

interface ExportButtonProps extends ButtonProps {
  disabled: boolean;
  loading: boolean;
  performExport: (type: ExportType) => void;
}

export function ExportButton({ disabled, loading, performExport, ...buttonProps }: ExportButtonProps) {
  const { t } = useTranslation();

  return (
    <Menu>
      <Menu.Target>
        <Button rightIcon={<IconDownload />} disabled={disabled} loading={loading} {...buttonProps}>
          {t('SMART_ASSISTANT.CONVERSATIONS_SECTION.EXPORT.TITLE')}
        </Button>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Label>{t('SMART_ASSISTANT.CONVERSATIONS_SECTION.EXPORT.LABEL')}</Menu.Label>
        <Menu.Item icon={<IconJson size={14} />} onClick={() => performExport(ExportType.JSON)}>
          {t('SMART_ASSISTANT.CONVERSATIONS_SECTION.EXPORT.JSON')}
        </Menu.Item>
        <Menu.Item icon={<IconPdf size={14} />} onClick={() => performExport(ExportType.PDF)}>
          {t('SMART_ASSISTANT.CONVERSATIONS_SECTION.EXPORT.PDF')}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
